import { Box, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocationContext } from "../context/LocationContext";

// Categories (later can come from JSON)
const categories = [
  { label: "Temple", icon: "🛕", slug: "Mandir" },
  { label: "Hospital", icon: "🏥", slug: "hospital" },
  { label: "Water Park", icon: "🎢", slug: "waterpark" },
  { label: "Restaurant", icon: "🍽", slug: "restaurant" },
  { label: "Mall", icon: "🛍", slug: "mall" },
  { label: "Park", icon: "🌳", slug: "citypark" },
];

const BrowseCategories = () => {
  const { city, setCity } = useLocationContext();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#FFFFFF",
        py: { xs: 5, md: 7 },
        borderTop: "1px solid rgba(13,59,102,0.06)",
      }}
    >
      <Container>
        {/* ===== HEADER ===== */}
        <Box sx={{ mb: 4, maxWidth: 560 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.7rem", md: "2.2rem" },
              fontWeight: 800,
              color: "var(--color-neon, #0D3B66)",
              letterSpacing: "-0.4px",
            }}
          >
            Browse by{" "}
            <Box component="span" sx={{ color: "#F4D35E" }}>
              Category
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 1,
              color: "rgba(13,59,102,0.7)",
              fontSize: "0.95rem",
              lineHeight: 1.6,
            }}
          >
            Quickly explore nearby places by category and discover what’s
            available around you.
          </Typography>
        </Box>

        {/* ===== CATEGORY CARDS (FLEXBOX ONLY) ===== */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 1.5, md: 2 },
          }}
        >
          {categories.map((cat) => (
            <Box
              key={cat.slug}
              onClick={() =>
                navigate(
                  `/city/${city.toLowerCase()}/${cat.slug.toLowerCase()}`,
                )
              }
              sx={{
                flex: {
                  xs: "1 1 calc(50% - 12px)",
                  sm: "1 1 calc(33.33% - 16px)",
                  md: "0 0 170px",
                },
                backgroundColor: "#FFFDF7",
                borderRadius: 2,
                p: { xs: 2.2, md: 2.6 },
                cursor: "pointer",
                textAlign: "center",
                border: "1px solid rgba(13,59,102,0.08)",
                transition:
                  "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
                boxShadow: "0 8px 22px rgba(0,0,0,0.06)",
                "&:hover": {
                  transform: { md: "translateY(-6px)" },
                  boxShadow: "0 16px 36px rgba(13,59,102,0.18)",
                  borderColor: "rgba(13,59,102,0.35)",
                },
              }}
            >
              {/* ICON */}
              <Box
                sx={{
                  fontSize: "2rem",
                  mb: 1,
                  color: "var(--color-neon, #0D3B66)",
                }}
              >
                {cat.icon}
              </Box>

              {/* LABEL */}
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "var(--color-neon, #0D3B66)",
                  fontSize: "0.95rem",
                }}
              >
                {cat.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default BrowseCategories;
